/**
 * Поле выбора периода с выпадающим календарем (fc-input + fc-popper + fc-period-calendar)
 *
 * Параметры:
 *  - value {Object} - Значение в формате { from: '00.00.0000', to: '00.00.0000', range: <rangeId> }
 *  - placeholder {string} - плейсхолдер в поле
 *  - clearable {Boolean} - возможность сброса
 *  - readMode {Boolean} - отображение только для чтения
 *  - inline {Boolean} - стиль оформления
 *  - invalid {Boolean} - невалидное значение (оформление)
 *  - valid {Boolean} - валидное значение (оформление)
 *  - error {string} - текст ошибки (если invalid: true)
 *  - disabled {Boolean} - заблокировать контрол
 *  - ranges {Boolean} - выводить список готовых диапазонов
 */

import { ViewModel as model } from './model';
import template from './template.html';
import './style.less';

import { registerComponent } from 'Utils/engine/register-component';
registerComponent('fc-period-picker', {
  model,
  template
});
